import { render, staticRenderFns } from "./detailCompetition.vue?vue&type=template&id=05c798fe&scoped=true"
import script from "./detailCompetition.vue?vue&type=script&lang=js"
export * from "./detailCompetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c798fe",
  null
  
)

export default component.exports